import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.px-form.is-moving-label input').on('focus',function(){
        $(this).parent().parent().addClass('is-filled');
    })
    $('.px-form.is-moving-label input').on('blur',function(){
        if($(this).val() == ''){
            $(this).parent().parent().removeClass('is-filled');
        }
    })
    $('.px-form.is-moving-label select').parent().parent().addClass('is-filled');
    var cta = ""; 
    $('.px-form').each(function(){
        cta = $(this).attr('data-change-cta');
    })
    //console.log(cta);
    if(cta != ''){
        $('.px-form .wpcf7-submit, .px-form input[type="submit"]').attr('value',cta);
    }

    $('.px-form form').on('submit',function(){
        if($('.g-recaptcha-response').length){
            console.log($('.g-recaptcha-response').val());
            if(!$('.g-recaptcha-response').val()){
                $('.g-recaptcha>div').css('border','1px solid red');
                return false;
            }
        }
    })
    /*$('.px-form.is-registration-to-db').on('submit',function(e){
        if($(this).hasClass('sendToSalesforce')){

        }else{
            e.preventDefault();
            //var isClean = true;
            //var formdata = $( this ).serializeObject();
            var formdata = new FormData($(this)[0]);
            //console.log(formdata);
            //formdata[] = {name:'action', value:'pix_register_doc'};
            formdata.append('action', 'pix_register_doc');
            //formdata += '&action=pix_register_doc';
            console.log(formdata);
            console.log('x');
            $('.px-form.is-registration-to-db input[type="submit"]').attr('disabled',true)
            $.ajax({
                url : ajaxurl,
                type: 'POST',
                data: formdata,
                action:"pix_register_doc",
                //cache: false,
                //contentType:false,
                processData:false,
            }).done(function( response ){
                console.log(response);
                if(response == 'ok'){
                    $('.px-form.is-registration-to-db').addClass('sendToSalesforce');
                }
            })
            return false;
        }
    })*/
})